import request from '@/utils/request.js'

export function getorderlist(data) {
  return request.get('/api/H5/orderuser/getorderlist', {
    params: data
  })
}

export function getorderetail(data) {
  return request.get('/api/H5/orderuser/getorderetail', {
    params: data
  })
}

export function delorder(data) {
  return request.get('/api/H5/orderuser/delorder', {
    params: data
  })
}

export function cancelpayorder(data) {
  return request.get('/api/H5/orderuser/cancelpayorder', {
    params: data
  })
}

export function refundpayorder(data) {
  return request.get('/api/H5/orderuser/refundpayorder', {
    params: data
  })
}

export function getorderitemcode(data) {
  return request.get('/api/H5/orderuser/getorderitemcode', {
    params: data
  })
}

export function getqueryorderstate(data) {
  return request.get('/api/H5/orderuser/getqueryorderstate', {
    params: data,
    noLoading: true
  })
}

export function getpointorderlist(data) {
  return request.get('/api/H5/orderuser/getpointorderlist', {
    params: data
  })
}

// 我的月卡
export function getordercardlist(data) {
  return request.get('/api/H5/orderuser/getordercardlist', {
    params: data
  })
}

// 确认使用具体咖啡机
export function confirmorderveminfo(data) {
  return request.get('/api/H5/orderuser/confirmorderveminfo', {
    params: data
  })
}

// 获取月卡明细
export function getcardorderitem(data) {
  return request.get('/api/H5/orderuser/getcardorderitem', {
    params: data
  })
}
